import SideMenu from '@/containers/side-menu/SideMenu.vue';
import RelateScheduleSpots from '@/pages/relate-show-schedule-spots/RelateScheduleSpots.vue';

export default {
  path: '/relate-show-schedule-spots',
  name: 'RelateScheduleSpots',
  components: {
    mainContent: RelateScheduleSpots,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'relate-show-schedule-spots',
    },
    breadcrumb: {
      title: 'Relacionar agenda para listagem de vagas',
      paths: [{ title: 'Sistema' }],
    },
  },
};
